<template>
  <div class="page">
    <Header :activeIndex="4" />
    <!-- contact -->
    <div class="contact_box w">
      <div class="item">
        <img src="../assets/images/contact/c1.png" alt="" />
        <span>WhatsAPP </span>
        <span>13543292500</span>
      </div>

      <div class="item">
        <img src="../assets/images/contact/c2.png" alt="" />
        <span>Room 205, 2nd Floor, No.2 shuaifu Street, </span>
        <span>Wanjiang Street, Dongguan city, Guangdong, China</span>
      </div>
      <div class="item">
        <img src="../assets/images/contact/c3.png" alt="" />
        <span>Email </span>
        <span>{{ recipientEmail }}</span>
      </div>
    </div>
    <!-- send message -->
    <div class="msg">
      <div class="w">
        <div class="left">
          <div class="btn">Leave A Message</div>
          <form @submit.prevent="submitForm">
            <input
              v-model.trim="form.name"
              type="text"
              placeholder="Full Name"
              name="name"
              required
            />
            <input
              v-model.trim="form.email"
              type="email"
              placeholder="Email"
              name="email"
              required
            />
            <input
              v-model.trim="form.subject"
              type="text"
              placeholder="Subject"
              name="subject"
              required
            />
            <textarea
              v-model.trim="form.message"
              name="message"
              cols="30"
              rows="10"
              placeholder="message"
              required
            ></textarea>
            <p v-if="statusMessage" :class="['status', statusType]">
              {{ statusMessage }}
            </p>
            <button class="submit" type="submit" :disabled="submitting">
              {{ submitting ? 'Sending...' : 'Send' }}
            </button>
          </form>
        </div>

        <div class="right">
          <div class="f18">contact our team</div>
          <div class="line"></div>
          <p>TEL：+86 13543292500</p>
          <p>
            ADD：Room 205, 2nd Floor, No.2 shuaifu Street, Wanjiang Street,
            <br />
            Dongguan city, Guangdong, China
          </p>
          <p>Email: {{ recipientEmail }}</p>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>
<script>
import Header from '../components/Header.vue'
import Footer from '../components/Footer.vue'
import contactConfig from '../config/contact'

export default {
  metaInfo: {
    title: '东莞市乔斯精密机械有限公司',
    meta: [
      {
        name: 'keywords',
        content: '东莞市乔斯精密机械有限公司,乔斯,精密,机械',
      },
      {
        name: 'description',
        content: '品质用心、技术创新、恪守信誉、追求完美',
      },
    ],
  },
  components: {
    Header,
    Footer,
  },
  data() {
    return {
      recipientEmail: contactConfig.recipientEmail,
      form: {
        name: '',
        email: '',
        subject: '',
        message: '',
      },
      submitting: false,
      statusMessage: '',
      statusType: '',
    }
  },
  methods: {
    resetStatus() {
      this.statusMessage = ''
      this.statusType = ''
    },
    async submitForm() {
      this.resetStatus()
      this.submitting = true

      try {
        const response = await fetch(contactConfig.apiUrl, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(this.form),
        })
        const result = await response.json()

        if (!response.ok || !result.success) {
          throw new Error(result.message || 'Send failed')
        }

        this.statusType = 'success'
        this.statusMessage = 'Message sent successfully. We will reply soon.'
        this.form = {
          name: '',
          email: '',
          subject: '',
          message: '',
        }
      } catch (error) {
        this.statusType = 'error'
        this.statusMessage = 'Failed to send message. Please try again later.'
        console.error('Contact form error:', error)
      } finally {
        this.submitting = false
      }
    },
  },
}
</script>
<style scoped>
.contact_box {
  height: 136px;
  margin: 60px auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.contact_box .item {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  font-size: 16px;
  color: #444444;
}
.contact_box .item img {
  width: 64px;
  height: 64px;
  margin-bottom: 27px;
}
.msg {
  position: relative;
  width: 100%;
  height: 426px;
  background-image: url(../assets/images/contact/bg.png);
  background-repeat: no-repeat;
  background-position: center;
  background-size: 100% 100%;
  font-size: 14px;
  color: #444444;
  padding-top: 24px;
}
.msg .w {
  display: flex;
}
.msg .left {
  width: 419px;
}
.msg .btn {
  font-size: 16px;
  background: #fff;
  width: 177px;
  height: 35px;
  text-align: center;
  line-height: 35px;
}
.msg input {
  width: 419px;
  height: 35px;
  line-height: 35px;
  border: 1px solid #bfbfbf;
  background: #f6f8fb;
  margin-top: 15px;
  display: block;
  padding: 0 20px;
  font-size: 14px;
}
.msg input:focus,
.msg textarea:focus {
  outline: none;
}
.msg textarea {
  width: 419px;
  height: 108px;
  line-height: 35px;
  border: 1px solid #bfbfbf;
  background: transparent;
  margin-top: 15px;
  display: block;
  padding: 0 20px;
  font-size: 14px;
}
.msg input.textarea::-webkit-input-placeholder {
  line-height: 20px;
}
.msg .status {
  margin-top: 12px;
  font-size: 13px;
  line-height: 1.5;
}
.msg .status.success {
  color: #2e7d32;
}
.msg .status.error {
  color: #c62828;
}
.msg .submit {
  width: 419px;
  height: 40px;
  background: #4682b4;
  line-height: 40px;
  border-radius: 4px;
  color: #fff;
  font-size: 14px;
  margin-top: 23px;
  border: none;
  cursor: pointer;
}
.msg .submit:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}
.msg .right {
  margin-left: 120px;
  margin-top: 50px;
}
.msg .right .line {
  width: 489px;
  height: 1px;
  background: #bfbfbf;
  margin: 25px 0 30px;
}
.msg .right p {
  padding-bottom: 20px;
}
</style>



// WEBPACK FOOTER //
// src/views/contact.vue